/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'

/* ++++++++++ --------------- EXPORT : TRENDING NOW V2 CONFIGURATION GENERAL SECTION - SORT CONFIG : STYLES --------------- ++++++++++ */
export default theme => ({
  featuredarticle: {
    '& .field': {
      '& .errormessage': {
        display: 'none'
      }
    },
    '& .datepickerdropdown': {
      '& .name-dropdown': {
        padding: pxToEm(8),
        width: 'auto !important'
      },
      '& .datepickerapply .datepicker .DayPicker .DayPicker-Months': {
        flexWrap: 'nowrap !important',
        justifyContent: 'space-around !important'
      },
      '& .actionpanel': {
        justifyContent: 'flex-end !important',
        '& .compare': {
          display: 'none'
        }
      }
    },
    '& .previewconfig': {
      '& .content': {
        '& > div': {
          maxWidth: pxToEm(400),
        },
        '& .articlecard': {
          width: 'calc(100% - 8px)',
          minWidth: ' calc(100% - 8px)',
        },
        '& .container': {
          maxWidth: pxToEm(400),
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          '& .articlecard': {
            height: '148px'
          }
        },
        '& .loadmore': {
          display: 'flex',
          width: pxToEm(180),
          height: pxToEm(36),
          padding: `${pxToEm(16)} 0`,
          justifyContent: 'center',
          alignItems: 'center',
          background: '#000',
          color: '#FFF',
          borderRadius: pxToEm(30),
          fontSize: pxToEm(14)
        },
        '& h3': {
          fontFamily: '"Source Serif Pro", Georgia, serif',
          paddingBottom: pxToEm(8),
          borderBottom: '3px solid #000'
        },
        '& svg': {
          position: 'relative'
        },
        '& .arrowwrap': {
          position: 'relative',
          width: 0
        },
        '& .leftarrow': {
          left: pxToEm(-8)
        },
        '& .rightarrow': {
          left: pxToEm(-16)
        }
      }
    }
  }
});
